/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { AuthContext } from "../../lib/AuthContext";
import ParentComponent from "../../lib/ParentComponent";
import firebase from "../../lib/firebase";

import Utils from "../../Utils";
import { NavLink } from "react-router-dom";
import ar from "../../locale";
import Loading from "../../lib/Loading";
import { title, toolbarOptions } from "../../constants";
import PhotoUploader from "../../lib/PhotoUploader";
import UserTable from "../../lib/UserTable";
import SearchSDK from "../../lib/SearchUser";
import { asyncContainer, Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
const AsyncTypeahead = asyncContainer(Typeahead);

export default class ChatroomEdit extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
      chatroom: {},
      loading: false,
      suggested_users: [],
      searching_user: false,
      flagged_messages: [],
      deleting: {},
      ignoring: {},
    };
    this.chatroomRef = firebase
      .database()
      .ref("chatrooms/" + this.props.match.params.key);
    this.chatRef = firebase.database().ref("chats/");
    this.userRef = firebase.database().ref("users/");
  }

  componentDidMount() {
    super.componentDidMount();
    document.title = title + " - " + ar.chatclubs;
    this.quill = new window.Quill("#quill-editor", {
      modules: {
        toolbar: toolbarOptions,
      },
      theme: "snow",
    });
    this.chatroomRef.on("value", (snapshot) => {
      if (!snapshot.exists()) {
        this.props.history.replace("/404");
      } else {
        this.state.chatroom = snapshot.val();
        this.quill.root.innerHTML = this.state.chatroom.policies;
        this.chatRef
          .child(this.state.chatroom.key)
          .orderByChild("flagged")
          .equalTo(true)
          .on("value", (res) => {
            this.state.flagged_messages =
              Utils.convertToArrayWithInsertionOrder(res.val());
            this.updateState();
          });
        this.updateState();
      }
    });
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.chatroomRef.off("value");
    if (this.chatRef) {
      this.chatRef.off("value");
    }
  }

  showLoading = (show) => {
    this.state.loading = show;
    this.updateState();
  };

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  saveAvatar = async (croppedImage) => {
    this.showLoading(true);
    this.uploadAvatar(croppedImage);
  };

  uploadAvatar = (media) => {
    let { chatroom } = this.state;
    if (media) {
      firebase
        .storage()
        .ref("chatrooms/" + chatroom.key)
        .put(media)
        .then((snapshot) => snapshot.ref.getDownloadURL())
        .then((downloadURL) => this.chatroomRef.update({ avatar: downloadURL }))
        .then(() => {
          this.showLoading(false);
          this.showSuccess(ar.upload_successful);
        })
        .catch((error) => {
          this.showLoading(false);
          this.showError(error.message);
        });
    }
  };

  updateChatroomDetails = () => {
    let name = this.name.value;
    let policies = this.quill.root.innerHTML;
    let policiesText = null;
    if (policies) {
      policiesText = this.$(policies).text(); //this is just for validation
    }
    if (name && policiesText) {
      this.showLoading(true);
      this.chatroomRef
        .update({
          name: name,
          policies: policies,
        })
        .then(() => {
          this.showLoading(false);
          this.showSuccess(ar.operation_successful);
        })
        .catch((error) => {
          this.showLoading(false);
          this.showError(error.message);
        });
    } else {
      this.showError(ar.enter_valid_details);
    }
  };

  onRemoveBan = (user) => {
    this.chatroomRef.child("banned_users").transaction((banned_users) => {
      banned_users = banned_users || [];
      if (banned_users.length <= 0) {
        return banned_users;
      } else {
        const userIndex = banned_users.findIndex((i) => i === user.uid);
        banned_users.splice(userIndex, 1);
        return banned_users;
      }
    });
  };

  searchUser = (text) => {
    this.state.searching_user = true;
    this.updateState();
    SearchSDK.searchUser(text).then((users) => {
      this.state.suggested_users =
        Utils.convertToArrayWithInsertionOrder(users);
      this.state.searching_user = false;
      this.updateState();
    });
  };

  onChange = ([user]) => {
    this.chatroomRef
      .child("banned_users")
      .transaction((banned_users) => {
        banned_users = banned_users || [];
        //delete user if joined
        this.chatroomRef.child("users").transaction((users) => {
          users = users || [];
          if (users.includes(user.uid)) {
            const userIndex = users.findIndex((item) => item === user.uid);
            users.splice(userIndex, 1);
            this.chatroomRef.update({ user_count: users.length });
            const roomIndex = user.chatrooms.findIndex(
              (item) => item === this.state.chatroom.key
            );
            user.chatrooms.splice(roomIndex, 1);
            this.userRef.child(user.uid).update({
              chatrooms: user.chatrooms,
            });
          }
          return users;
        });
        if (!banned_users.includes(user.uid)) {
          banned_users.push(user.uid);
          return banned_users;
        }
        return banned_users;
      })
      .then(() => {
        this.typeahead.getInstance().clear();
        this.showSuccess(ar.operation_successful);
      })
      .catch((error) => {
        this.showError(error.message);
      });
  };

  deleteFlaggedMessage = (message) => {
    this.chatRef
      .child(this.state.chatroom.key + "/" + message._id)
      .update({
        flagged: false,
        deleted: true,
      })
      .then((res) => {
        this.showSuccess(ar.operation_successful);
      })
      .catch((error) => {
        this.showError(error.message);
      });
  };

  deleteConfirmation = (message) => {
    this.confirm(null, this.deleteFlaggedMessage.bind(this, message));
  };

  ignoreConfirmation = (message) => {
    this.confirm(null, this.ignoreFlaggedMessage.bind(this, message));
  };

  ignoreFlaggedMessage = (message) => {
    this.chatRef
      .child(this.state.chatroom.key + "/" + message._id)
      .update({
        flagged: null,
        flaggedBy: null,
      })
      .then((res) => {
        this.showSuccess(ar.operation_successful);
      })
      .catch((error) => {
        this.showError(error.message);
      });
  };

  renderMessages = (message, index) => {
    return (
      <tr key={message._id}>
        <td>
          {message.user && message.user.avatar && (
            <img
              src={message.user.avatar}
              className="avatarc rounded-circle"
              width="30"
              height="30"
            />
          )}
          <span className="pr-2 pl-2">{message.user.name}</span>
        </td>
        <td className="min-width200">
          {message.text}
          {message.image && (
            <a href={message.image} target="_blank" rel="noopener noreferrer">
              <img src={message.image} height="100" />
            </a>
          )}
          {message.video && (
            <a href={message.video} target="_blank" rel="noopener noreferrer">
              <img src={message.poster} height="100" />
            </a>
          )}
        </td>
        <td>
          {!this.state.deleting[message._id] && (
            <i
              className="fa fa-trash text-danger cursor-pointer"
              title={ar.delete}
              onClick={this.deleteConfirmation.bind(this, message)}
            ></i>
          )}
          {this.state.deleting[message._id] && (
            <div
              className="d-inline-block spinner-border spinner-border-sm text-danger"
              role="status"
            ></div>
          )}
        </td>
        <td>
          <i
            className="fa fa-undo text-success cursor-pointer"
            title={ar.ignore}
            onClick={this.ignoreConfirmation.bind(this, message)}
          ></i>
        </td>
      </tr>
    );
  };

  render() {
    let { chatroom, flagged_messages, loading } = this.state;
    return (
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card no-toolbar border-0">
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-9 mt-2">
                      <h2 className="card-title">{ar.chatclubs}</h2>
                      {chatroom && (
                        <h5 className="card-subtitle mb-0">
                          {ar.subscribers} -{" "}
                          {chatroom.users ? chatroom.users.length : 0}
                        </h5>
                      )}
                    </div>
                    <div className="col-sm-3 mt-2 text-md-left">
                      <NavLink
                        to="/chatroom/add"
                        className="btn btn-info btn-rounded"
                      >
                        {ar.add_new}
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-8">
              <div className="card">
                <div className="card-body">
                  <div className="form-group">
                    <label
                      htmlFor="inputname"
                      className="control-label col-form-label font-weight-bold"
                    >
                      <span className="text-danger ml-1">*</span>
                      {ar.name}
                    </label>
                    <input
                      type="text"
                      ref={(e) => (this.name = e)}
                      className="form-control"
                      defaultValue={chatroom.name}
                      id="inputname"
                      placeholder={ar.enter_name}
                    />
                  </div>
                  <div className="mt-5 mb-3 font-weight-bold">
                    <p>
                      <span className="text-danger ml-1">*</span>
                      {ar.enter_policies}
                    </p>
                  </div>
                  <div id="quill-editor" className="min-h200"></div>
                  <div className="button-group mt-3">
                    <button
                      type="button"
                      className="min-w100 btn waves-effect waves-light btn-rounded btn-info"
                      onClick={this.updateChatroomDetails}
                    >
                      {ar.save}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <PhotoUploader
                onSaveAvatar={this.saveAvatar}
                avatar={chatroom.avatar}
              />
            </div>
          </div>
          <div className="card no-toolbar border-0 mb-0">
            <div className="card-body">
              <div className="row">
                <div className="col-sm-6 mt-2">
                  <h2 className="card-title">{ar.banned_users}</h2>
                  <h5 className="card-subtitle mb-0">
                    {ar.total} - {(chatroom.banned_users || []).length}
                  </h5>
                </div>
                <div className="col-sm-6 mt-2 text-md-left">
                  <h5>{ar.ban_users}</h5>
                  <AsyncTypeahead
                    ref={(e) => (this.typeahead = e)}
                    id="search-user"
                    multiple={false}
                    isLoading={this.state.searching_user}
                    onSearch={this.searchUser}
                    onChange={this.onChange}
                    placeholder={ar.search_name_email_contact}
                    emptyLabel={ar.no_match_found}
                    options={this.state.suggested_users}
                    labelKey={(option) =>
                      `${option.name} ${option.email} ${option.contact}`
                    }
                    renderMenuItemChildren={(option, props) => (
                      <div className="d-flex flex-row">
                        {option.photoURL && (
                          <img
                            src={option.photoURL}
                            className="ml-2 avatac rounded-circle"
                            width="30"
                            height="30"
                            alt="avatar"
                          />
                        )}
                        <div className="d-flex flex-column flex1 justify-content-center">
                          {option.name}
                        </div>
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <UserTable
                userids={chatroom.banned_users || []}
                allowdelete={true}
                deletetext={ar.unblock}
                onDelete={this.onRemoveBan}
              />
            </div>
          </div>
          <div className="card no-toolbar border-0 mb-0">
            <div className="card-body">
              <div className="row">
                <div className="col-sm-12 mt-2">
                  <h2 className="card-title">{ar.flagged_messages}</h2>
                  <h5 className="card-subtitle mb-0">
                    {ar.total} - {flagged_messages.length}
                  </h5>
                </div>
              </div>
              <table
                id="sawtable"
                className="mt-3 tablesaw table-bordered table-striped table-hover table no-wrap"
                data-tablesaw-mode="stack"
              >
                <thead>
                  <tr>
                    <th scope="col" className="border">
                      {ar.sender}
                    </th>
                    <th scope="col" className="border min-width200">
                      {ar.message}
                    </th>
                    <th scope="col" className="border">
                      {ar.delete}
                    </th>
                    <th scope="col" className="border">
                      {ar.ignore}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.flagged_messages.map((message, index) =>
                    this.renderMessages(message, index)
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <Loading show={loading} />
      </div>
    );
  }
}
